export default __webpack_public_path__ + "static/media/Member_JoeWan.27be5bf0.jpg";